import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class DataSourceCommonSettings extends VisualizatorSettings {
  constructor(settings) {
    super();

    this.channels = []; // type: array of ChannelCommonSettings
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "id") {
        this.id = settings.id;
      } else if (key == "channels" || key == "marks") {
        this[key] = VisualizatorSettings.copySettingsArray(settings[key]);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new DataSourceCommonSettings(this);
  }
}
